import apiBaseUrl from '../../utils/config';

class ContentService {
  getToken() {
    return localStorage.getItem('jwt');
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async saveContent(data) {
    const res = await fetch(`${apiBaseUrl}/content/saveContent`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to save content');
    return res.text();
  }

  async updateContent(id, data) {
    const res = await fetch(`${apiBaseUrl}/content/updateContent/${id}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to update content');
    return res.text();
  }

  async getContent(id) {
    const res = await fetch(`${apiBaseUrl}/content/getContent/${id}`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error('Failed to fetch content');
    return res.json();
  }

  async listContent() {
    const res = await fetch(`${apiBaseUrl}/content/listContent`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error('Failed to list content');
    return res.json();
  }

  async deleteContent(id) {
    const res = await fetch(`${apiBaseUrl}/content/deleteContent/${id}`, {
      method: 'DELETE',
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error('Failed to delete content');
    return res.text();
  }

  async getMenuStructure() {
    const res = await fetch(`${apiBaseUrl}/content/menuStructure`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error('Failed to get menu structure');
    return res.json();
  }

  async searchContent({ title, category, extraData }) {
    const params = new URLSearchParams();
    if (title) params.append('title', title);
    if (category) params.append('category', category);
    if (extraData) params.append('extraData', extraData);

    const res = await fetch(`${apiBaseUrl}/content/search?${params.toString()}`, {
      headers: this.getAuthHeaders(),
    });
    if (!res.ok) throw new Error('Failed to search content');
    return res.json();
  }
}

export default new ContentService();
